import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import config from '../config/config';
import { handlerError } from '../errors/handlerError';
import { useTranslation } from 'react-i18next';
import { loadToken } from '../utils';
import { useLocation } from 'react-router-dom';

export default function useLanguaje() {
  const { i18n, t } = useTranslation();

  const { search } = useLocation();

  const lang = new URLSearchParams(search).get('lang') || localStorage.getItem('lang') || 'es';

  const langauges = [
    { value: 'es', label: t('ES') },
    { value: 'en', label: t('EN') }
  ];

  const initialLangValue = langauges.find(({ value }) => value === lang);
  const [valueLang, setValueLang] = useState(initialLangValue);

  const selectRef = useRef();

  const token = loadToken();

  useEffect(() => {
    // localStorage.setItem('lang', lang);
    // i18n.changeLanguage(lang);

    if (lang) {
      i18n.changeLanguage(lang);
      setValueLang(langauges.find(item => item.value === lang));
      localStorage.setItem('lang', lang);
    } else if (localStorage.getItem('lang')) {
      i18n.changeLanguage(localStorage.getItem('lang'));
    }
  }, []);

  useEffect(() => {
    if (lang) setValueLang(langauges.find(item => item.value === lang));
    if (!lang)
      setValueLang(
        localStorage.getItem('lang')
          ? langauges.find(item => item.value === localStorage.getItem('lang'))
          : langauges[0]
      );
  }, []);

  const changeLanguage = value => {
    localStorage.setItem('lang', value);
    setValueLang(langauges.find(item => item.value === value));

    i18n.changeLanguage(value);
  };

  const updateUser = event => {
    changeLanguage(event.value);
    axios
      .put(
        `${config.DOMAIN}users`,
        { lang: event.value },
        {
          headers: {
            apikey: config.apikey,
            token
          }
        }
      )
      .then(res => {})
      .catch(error => {
        handlerError(error);
      });
  };

  const getLangForSend = () => {
    let returnLang;
    if (lang) {
      returnLang = lang;
    } else if (localStorage.getItem('lang')) {
      returnLang = localStorage.getItem('lang');
    } else {
      returnLang = langauges[0].value;
    }
    return returnLang;
  };

  return {
    langauges,
    changeLanguage,
    updateUser,
    selectRef,
    valueLang,
    getLangForSend
  };
}
